import {createFileRoute} from '@tanstack/react-router';
import {CreditAccountPPIClosePage} from '../../../../../../../features/credit/pages/CreditAccountPPIClosePage/CreditAccountPPIClosePage';

export const Route = createFileRoute(
  '/_protected/accounts/credits/$accountId/ppi/close/confirm',
)({
  component: CreditAccountPPIClosePage,
});
